import { createFeatureSelector, createReducer, on } from "@ngrx/store";
import { Item } from "src/app/models/item";
// import * as AppState from "src/app/reducers";
import { CartItem } from "../cartItem";
import * as CartActions from "./cart.actions";

import * as CartUtils from './../cart-utils';
import * as AllAppState from "src/app/state/state";

export const cartFeatureKey = 'cart';

// export const selectCartState = createFeatureSelector('cart');

export interface AppState extends AllAppState.AppState {
    cart: CartState;
}

export interface CartState {
    searchItems: Item[];
    searchResetSignal: boolean;
    cartItems: CartItem[];
    cartTotal: number;
    cartTax8: number;
    cartTax18: number;
    cartGrandTotal: number;
};

export const initialState: CartState = {
    searchItems: [],
    searchResetSignal: false,
    cartItems: [],
    cartTotal: 0,
    cartTax8: 0,
    cartTax18: 0,
    cartGrandTotal: 0
};

export const reducer = createReducer(
    initialState,
    on(CartActions.addToCart, (state, action): CartState => {
        const updatedCartItems = CartUtils.addOneItem(action.item, state.cartItems);
        const cartProps = CartUtils.calculateCartProps(updatedCartItems);
        return {
            ...state,
            cartItems: updatedCartItems,
            ...cartProps
        }
    }),
    on(CartActions.addOne, (state, action): CartState => {
        const updatedCartItems = CartUtils.changeItemQty(action.cartItem, action.cartItem.qty + 1, state.cartItems);
        const cartProps = CartUtils.calculateCartProps(updatedCartItems);
        return {
            ...state,
            cartItems: updatedCartItems,
            ...cartProps
        }
    }),
    on(CartActions.removeOne, (state, action): CartState => {
        const updatedCartItems = CartUtils.changeItemQty(action.cartItem, action.cartItem.qty - 1, state.cartItems);
        const cartProps = CartUtils.calculateCartProps(updatedCartItems);
        return {
            ...state,
            cartItems: updatedCartItems,
            ...cartProps
        }
    }),
    on(CartActions.invertLine, (state, action): CartState => {
        const updatedCartItems = CartUtils.changeItemQty(action.cartItem, action.cartItem.qty * (-1), state.cartItems);
        const cartProps = CartUtils.calculateCartProps(updatedCartItems);
        return {
            ...state,
            cartItems: updatedCartItems,
            ...cartProps
        }
    }),
    on(CartActions.removeLine, (state, action): CartState => {
        const updatedCartItems = CartUtils.removeCartItem(action.cartItem, state.cartItems);
        const cartProps = CartUtils.calculateCartProps(updatedCartItems);
        return {
            ...state,
            cartItems: updatedCartItems,
            ...cartProps
        }
    }),
    on(CartActions.resetCart, (state): CartState => {
        return initialState;
    }),
    on(CartActions.itemSearchSuccess, (state, action): CartState => {
        // TODO: searchItems[] propertysine eklenecek ve length = 1 ise Cart'a eklenecek
        const foundItems = action.items;
        // console.log('found items in reducer: ', foundItems.length);
        if (foundItems.length === 1) {
            const updatedCartItems = CartUtils.addOneItem(foundItems[0], state.cartItems);
            const cartProps = CartUtils.calculateCartProps(updatedCartItems);
            return {
                ...state,
                searchItems: foundItems,
                searchResetSignal: true,
                cartItems: updatedCartItems,
                ...cartProps
            }
        } else if (foundItems.length > 1) {
            return {
                ...state,
                searchItems: foundItems,
                searchResetSignal: true,
            }
        } else {
            return {
                ...state
            }
        }
    }),
    on(CartActions.searchFieldReset, (state): CartState => {
        return {
            ...state,
            searchResetSignal: false
        }
    })
);

